import { verifyOTP } from "../../../fakebackend_helper";
import { apiError } from "../register/reducer";
import { otpSuccessful, otpUserFailed } from "./reducer";


export const verifyOtp = (otp, navigate) => async (dispatch) => {
    try {
        let response;
        if (process.env.REACT_APP_API_URL) {
            response = verifyOTP(otp);
            const data = await response;
            console.log(data);
            if (data.status === "SUCCESS") {
                dispatch(otpSuccessful(data));
                navigate("/login");
            } else {
                dispatch(otpUserFailed(data));
            }
        }
    } catch (error) {
        dispatch(apiError(error.response.data));
    }
}